import { IGameSeo, IProject, IProvider } from '../interfaces';

export const DEFAULT_VERIFICATION_CODE_TIME: number = 300;

export const PROVIDER_LIST: IProvider[] = [
    {
        id: 'yookassa',
        title: 'yookassa',
        methods: [ 'card', 'yooMoney' ],
        currency: 'RUB',
        fromCharCode: String.fromCharCode(8381),
    },
    {
        id: 'stripe',
        title: 'stripe',
        methods: [ 'card' ],
        currency: 'USD',
        fromCharCode: String.fromCharCode(36),
    },
    {
        id: 'yandex-pay',
        title: 'yandexPay',
        methods: [ 'card' ],
        currency: 'RUB',
        fromCharCode: String.fromCharCode(8381),
    },
    {
        id: 'inqud',
        title: 'inqud',
        methods: [ 'crypto' ],
        currency: 'USD',
        fromCharCode: String.fromCharCode(36),
    },
];

export const VERIFICATION_TIME_STYLE: any = {
    color: '#2368a2',
    cursor: 'pointer',
    textDecoration: 'underline',
}

export const PROJECTS: IProject[] = [
    {
        id: 'familytown',
        title: 'familytown'
    },
    {
        id: 'neuroarena',
        title: 'neuroarena'
    },
    {
        id: 'islandm3',
        title: 'islandm3'
    },
];

const origin: string = window.location.origin;
const dir: string = 'main_images';
const staticFilesDir: string = 'static_files';
const hornyDir: string = 'horny_images';

export const HEADER_LOGO: string = `${origin}/${dir}/pf.webp`;
export const GUEST_LOGO: string = `${origin}/${dir}/guest.webp`;
export const PROFILE_ID_LOGO: string = `${origin}/${dir}/profile_user_id.webp`;
export const PROFILE_SETTINGS_LOGO: string = `${origin}/${dir}/profile_settings.webp`;
export const PROFILE_TRANSACTIONS_LOGO: string = `${origin}/${dir}/profile_transactions.webp`;
export const PROFILE_LOGOUT_LOGO: string = `${origin}/${dir}/profile_logout.webp`;
export const PROFILE_LOGO: string = `${origin}/${dir}/profile.webp`;
export const NO_PURCHASES_LOGO: string = `${origin}/${dir}/no_purchases.webp`;
export const MAIN_PAGE_ART: string = `${origin}/${dir}/main_page_art.webp`;
export const PROFILE_SUPPORT_LOGO: string = `${origin}/${dir}/profile_support.webp`;
export const HORNY_IP_BLOCK_LOGO: string = `${origin}/${hornyDir}/block.webp`;
export const HORNY_BACKGROUND_LOGO: string = `${origin}/${hornyDir}/bg.png`;

export const PLAY_HUB_PROJECT: string = 'playhub';
export const WEB_SOURCE: string = 'web';

export const LOCALES: string[] = [ 'ru', 'en', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'zh'  ];

export const GAME_IFRAME_ID: string = 'GAME_IFRAME_ID';
export const IFRAME_ORIGINS: string[] = [
    window.location.origin,
    'https://dev1.playflock.com',
    'https://familytown.playflock.com',
];

export const DOMAINS: string[] = [ 'hornylegends' ];
export const STATIC_FILES_PATH: string = `${origin}/${staticFilesDir}`;

export const DEFAULT_PAGE_HEAD_DATA: IGameSeo = {
    faviconImage: 'favicon.ico',
    appleTouchImage: 'logo192.webp',
    description: 'All Playflock games in one service! Use your personal account for individual settings and contact with support',
    keywords: 'authorization, support, help, game, games, gaming platform',
    ogUrl: origin,
    ogType: 'website',
    title: 'Playhub',
    ogTitle: 'Playhub',
    ogDescription: 'All Playflock games in one service! Use your personal account for individual settings and contact with support',
    ogImage: 'logo512.webp',
    ogSiteName: 'Playhub',
}

export const GET_UNREAD_MSG_INTERVAL: number = 5 * 60 * 1000;